import { applyLanguage, useTranslation } from "@repo/i18n";
import { css } from "@repo/styled-system/css";

const LANGS = [
  { value: "fr", label: "FR" },
  { value: "en", label: "EN" },
] as const;

/**
 * Compact FR/EN switch for the staff header. The shell defaults to FR (ADR-0013); this toggle lets an
 * operator flip to EN in place — `applyLanguage` swaps i18next + `<html lang>` and persists the choice
 * with NO navigation. react-i18next re-renders every consumer on `languageChanged`, so `aria-pressed`
 * tracks the active language without local state. A labelled group, keyboard-operable.
 */
export function LanguageToggle() {
  const { t, i18n } = useTranslation();
  const current = i18n.language?.startsWith("en") ? "en" : "fr";

  return (
    <fieldset
      aria-label={t("shell.language")}
      className={css({
        display: "inline-flex",
        borderWidth: "1px",
        borderColor: "border.default",
        rounded: "md",
        overflow: "hidden",
        p: "0",
        m: "0",
      })}
    >
      {LANGS.map((lang) => {
        const active = current === lang.value;
        return (
          <button
            key={lang.value}
            type="button"
            lang={lang.value}
            aria-pressed={active}
            onClick={() => {
              if (!active) void applyLanguage(lang.value);
            }}
            className={css({
              px: "2.5",
              py: "1",
              fontSize: "xs",
              fontWeight: "semibold",
              cursor: "pointer",
              bg: active ? "colorPalette.default" : "transparent",
              color: active ? "colorPalette.fg" : "fg.muted",
              _hover: active ? {} : { bg: "bg.muted", color: "fg.default" },
            })}
          >
            {lang.label}
          </button>
        );
      })}
    </fieldset>
  );
}
